module.exports = __webpack_public_path__ + "img/riverBasins.efe87855.png";